(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-redux"), require("lodash"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-redux", "lodash", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["ui-react-common"] = factory(require("react"), require("react-redux"), require("lodash"), require("react-dom"));
	else
		root["ui-react-common"] = factory(root["react"], root["react-redux"], root["_"], root["react-dom"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__65932__, __WEBPACK_EXTERNAL_MODULE__59130__, __WEBPACK_EXTERNAL_MODULE__16252__, __WEBPACK_EXTERNAL_MODULE__10094__) => {
return 